<template>
    <div>
        <header>
            <div class="container-fluid">
                <div class="pt-6">
                    <div class="row align-items-end">
                        <div class="col-sm col-12">
                            <h1 class="h2 ls-tight">Permisos</h1>
                        </div>
                    </div>
                </div>
            </div>
        </header>
        <main class="py-6 bg-surface-secondary">
            <div class="container-fluid">
                <div class="row">
                    <div class="col-12 col-md-6 vstack gap-3">
                        <div class="vstack gap-10">
                            <div>
                                <h5>Lista de permisos</h5>
                                <p class="text-sm text-muted mt-1">Permisos para el aceso al menu</p>
                                <div class="vstack gap-3 mt-4">
                                    <div v-for="(item, index) in items" :key="index"
                                        :class="selected == item.id ? 'bg-white border-primary' : ''"
                                        class="w-100 row justify-content-between align-items-center border border-primary-hover text-heading p-3 rounded-2">
                                        <div class="col-8 d-flex align-items-center">
                                            <i :class="item.icon" class="text-lg me-3"></i>
                                            <span class="text-body text-sm font-semibold">
                                                <div class="ms-4">
                                                    <font style="vertical-align: inherit;">
                                                        <font style="vertical-align: inherit;">{{ item.name }}</font>
                                                    </font>
                                                    <span class="d-block text-sm text-muted">{{
                                                        item.description
                                                    }}</span>
                                                </div>
                                            </span>
                                        </div>
                                        <div class="col-auto">
                                            <div class="d-flex align-items-center justify-content-between gap-6">
                                                <div>
                                                    <span @click="UP(index, index - 1)" v-if="index > 0 && globalViewOption('PermissionOrder')"
                                                        class="cursor-pointer text-sm text-muted text-danger-hover font-semibold">
                                                        <i class="bi bi-arrow-up-short me-2"></i>
                                                    </span>
                                                    <span @click="DOWN(index, index + 1)"
                                                        v-if="index < (items.length - 1) && globalViewOption('PermissionOrder')"
                                                        class="cursor-pointer text-sm text-muted text-danger-hover font-semibold">
                                                        <i class="bi bi-arrow-down-short me-2"></i>
                                                    </span>
                                                    <span @click="ONCHANGE(item.id)"
                                                        v-if="!Array.isArray(item.items) ? true : item.items.length > 0"
                                                        :class="selected == item.id ? 'text-primary' : ''"
                                                        class="cursor-pointer text-sm text-muted text-primary-hover font-semibold">
                                                        <i :class="selected == item.id ? 'bi-check-circle' : 'bi-circle'"
                                                            class="bi me-2"></i>
                                                    </span>
                                                    <router-link :to="{ name: 'PermissionUpdate', params: { id: item.id } }" v-if="globalViewOption('PermissionUpdate')">
                                                        <span
                                                            class="cursor-pointer text-sm text-muted text-primary-hover font-semibold">
                                                            <i class="bi bi-pencil-square me-2"></i>
                                                        </span>
                                                    </router-link>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-12 col-md-6 vstack gap-3">
                        <permission-item :data="item_selected" :moveItem="moveItem" :loading="loading_two"/>
                    </div>
                    <div class="col-12" v-if="loading">
                        <div class="text-center">
                            <div class="spinner-border text-primary" role="status">
                                <span class="sr-only">Loading...</span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </main>
    </div>
</template>
<script>
import PermissionItem from './items/Index'
export default {
    components: { PermissionItem },
    data() {
        return {
            loading: true,
            loading_two: false,
            id: null,
            items: [],
            selected: this.$route.query.selected,
            item_selected: null,
            count: 0
        }
    },
    mounted() {
        this.INIT()
        this.SELECTED_CHANGE()
    },
    methods: {
        moveItem: function (data, from, to, api) {
            let vue = this
            let f = data.splice(from, 1)[0];
            data.splice(to, 0, f);
            let order = data.map((item, index) => {
                return {
                    id: item.id,
                    index: index
                }
            });
            axios({ url: api, method: 'PUT', data: { order: order } })
                .catch((err) => {
                   let message = err.response ? err.response.data.message : err.message
                        vue.$swal({ toast: true, icon: 'error', title: message, position: 'top-end', showConfirmButton: false, timer: 3000 })
                })
        },
        INIT: function () {
            let vue = this
            axios({ url: '/permissions', method: 'GET' })
                .then((resp) => {
                    vue.items = resp.data
                })
                .finally((resp) => {
                    vue.loading = false
                })
        },
        UP: function (index, old) {
            let vue = this
            vue.moveItem(vue.items, index, old, '/order/permissions')
        },
        DOWN: function (index, old) {
            let vue = this
            vue.moveItem(vue.items, index, old, '/order/permission/items')
        },
        ONCHANGE: function(id){
            let vue = this
            vue.selected = id
            vue.loading_two = true
        },
        SELECTED_CHANGE: function () {
            let vue = this
            if(vue.selected){
                vue.loading_two = true
                axios({ url: '/permissions/' + vue.selected, method: 'GET' })
                    .then((resp) => {
                        vue.item_selected = resp.data
                    })
                    .finally((resp) => {
                        vue.loading_two = false
                    })
            }
        },
    },
    watch: {
        selected: {
            handler (e) {
                this.SELECTED_CHANGE()
            },
            deep: true
        }
    }
}
</script>



// WEBPACK FOOTER //
// src/pages/settings/permissions/Index.vue